// import HomePageSlider from "../../assets/images/home-images/slider1.gif"
import SportsImg from "../../assets/images/home-images/sportbook.webp";
import BannerSports from "../../assets/images/home-images/sports-banner.webp";
import HorseRacingImage from "../../assets/images/home-images/horse-racing.webp";
import GreyhoundRacingImage from "../../assets/images/home-images/greyhound-racing.webp";
import {
  CASINO_ROUTE,
  CRICKET_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  FOOTBALL_ROUTE,
  IN_PLAY_ROUTE,
  POPULAR_EVENTS_ROUTE,
  SPORTS_BOOK_ROUTE,
} from "@hypexone/uicore";
import Mac88 from '../../assets/images/provider_img/mac88.png';
import Mac88Virtual from '../../assets/images/provider_img/mac88-virtual.png';
import FunGames from '../../assets/images/provider_img/fun-games.png';
import Evolution from '../../assets/images/provider_img/evolution-gaming.png';
import Spribe from '../../assets/images/provider_img/spribe.png';
import Turbo from '../../assets/images/provider_img/turbo-games.png';
import Smartsoft from '../../assets/images/provider_img/smartsoft.png';
import Ezugi from '../../assets/images/provider_img/ezugi.png';
import Jili from '../../assets/images/provider_img/Jili.png';
import AeSexy from '../../assets/images/provider_img/sexy.png';
import Playtech from '../../assets/images/provider_img/playtech.png';
import Betsoft from '../../assets/images/provider_img/betsoft.png';
import Gamzix from '../../assets/images/provider_img/gamzix.png';
import BetGames from '../../assets/images/provider_img/betgamestv.png';
import MacExcite from '../../assets/images/provider_img/mac_excite.png';
import RG from '../../assets/images/provider_img/royal-gaming.png';

export const gamesImagesData: {
  title: string;
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
}[] = [
  {
    title: 'Mac88',
    imageSrc: "https://cdn.storyverse.work/mac88.gif",
    alt: "mac88",
    url: `/casino?subProvider=MAC88+LIVE&category=ALL`,
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
  {
    title: 'Sports',
    imageSrc: BannerSports,
    alt: "live-events",
    url: `${IN_PLAY_ROUTE}`,
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
  {
    title: 'Sports Book',
    imageSrc: SportsImg,
    url: SPORTS_BOOK_ROUTE,
    alt: "sportsbook",
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
];

export const HorseRacingImagesData: {
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
}[] = [
  {
    imageSrc: HorseRacingImage,
    url: "/exchange_sports/horserace",
    alt: "horse-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
  {
    imageSrc: GreyhoundRacingImage,
    url: "/exchange_sports/greyhound",
    alt: "greyhound-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
];

export const HomeProvidersIcons = [
  { icon: RG, subProviderName: 'ROYAL GAMING' },
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Betsoft, subProviderName: 'BETSOFT' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: MacExcite, subProviderName: 'MAC EXCITE' },
  // { icon: Live88, subProviderName: 'Bombay Live' },
  // { icon: King, subProviderName: 'KINGMAKER' },
];

export const HomeMobProvidersIcons = [
  { icon: RG, subProviderName: 'ROYAL GAMING' },
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT' },
  { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  { icon: MacExcite, subProviderName: 'MAC EXCITE' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  // { icon: Betsoft, subProviderName: 'BETSOFT' },
  // { icon: Live88, subProviderName: 'Bombay Live' },
  // { icon: King, subProviderName: 'KINGMAKER' },
];
